import React from 'react'
import { Image, ImageBase } from '../../../../utils/image'
import { pageheaderHeroSrc, pageheaderHeroSrcSet } from '../../../../utils/imageSizes'
import { SpaarneCentrumType } from '../../../../utils/spaarneIcons'
import { GenericPageHeader, HeroPageHeader } from '../../../sharedLayout/pageheader'
import { PageHeaderNavLayout } from '../../../sharedLayout/pageheaderUtils'
import { ContactItem } from '../../cmsPageState'

type SpaarnePageHeaderProps = {
  title: string
  intro: string
  link?: { url: string; title: string }
  image?: ImageBase
  breadcrumbs: { url: string; title: string }[]
  menuItems?: { url: string; title: string; active: boolean }[]
  menuOpened?: boolean
  toggleMenu?: () => void
  centrum?: { title: SpaarneCentrumType; url: string }
  contactItems: ContactItem[]
  appointmentUrl?: string
  waitingTimesUrl?: string
}

export const SpaarnePageHeader = (props: SpaarnePageHeaderProps) =>
  props.centrum ? (
    <HeroPageHeader
      kind="centra-spaarne"
      title={props.title}
      intro={props.intro}
      link={props.link}
      breadcrumbs={props.breadcrumbs}
      visual={
        <div className="pageheader__visual">
          <div className='pageheader__visual--container'>
            <div className='fit-object'>
              {props.image ? (
                <Image
                src={pageheaderHeroSrc}
                srcset={pageheaderHeroSrcSet}
                sizes="(min-width: 81.5rem) 1224px, 100vw"
                lazyload={false}
                classNames={{ image: 'pageheader__image', picture: 'pageheader__wrapper' }}
                alt={props.image.alt}
                urls={props.image.urls}
                width="1220"
                height="615"
              />
            ) : undefined }
            </div>
          </div>
        </div>
      }
      topTasks={
        <PageHeaderNavLayout
          kind="centrum"
          appointmentUrl={props.appointmentUrl}
          centrumLogo={props.centrum}
          contactItems={props.contactItems}
          waitingTimesUrl={props.waitingTimesUrl}
          items={props.menuItems}
          menuOpened={props.menuOpened || false}
        />
      }
    />
  ) : (
    <GenericPageHeader
      kind="spaarne"
      title={props.title}
      intro={props.intro}
      image={props.image}
      link={props.link}
      breadcrumbs={props.breadcrumbs}
      extraJSXBelowText={
        props.menuItems &&
        props.menuItems.length > 1 && (
          <PageHeaderNavLayout
            kind="on-page-nav"
            appointmentUrl={props.appointmentUrl}
            centrumLogo={props.centrum}
            contactItems={props.contactItems}
            waitingTimesUrl={props.waitingTimesUrl}
            items={props.menuItems}
            menuOpened={props.menuOpened || false}
            toggleMenu={props.toggleMenu}
          />
        )
      }
    />
  )
